import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users-roles',
  templateUrl: './users-roles.component.html',
  styleUrls: ['./users-roles.component.css']
})
export class UsersRolesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
